import { findFirstNonEmptyString } from "@product/scmp-sdk";
import type { FunctionComponent, ReactNode } from "react";
import { graphql, useFragment } from "react-relay";

import type { healthAndHappinessItemQuery$key } from "scmp-app/queries/__generated__/healthAndHappinessItemQuery.graphql";
import type { CustomQueryParameters } from "scmp-app/types/gtm";

import AvatarFirst from "./avatar-first.png";
import AvatarSecond from "./avatar-second.png";
import AvatarThird from "./avatar-third.png";
import {
  AvatarContainer,
  Container,
  DialogContainer,
  Headline,
  HeadlineContainer,
  StyledAvatarImage,
  StyledButton,
  StyledDialog,
  TextContainer,
} from "./styles";

type Props = {
  customQueryParameters: CustomQueryParameters;
  index: number;
  reference: healthAndHappinessItemQuery$key;
};

interface AvatarMap {
  [key: number]: ReactNode;
}

export const HealthAndHappinessItem: FunctionComponent<Props> = ({
  customQueryParameters,
  index,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment healthAndHappinessItemQuery on Article {
        ...entityLink
        headline
        socialHeadline
      }
    `,
    reference_,
  );

  const renderHeadline = () => {
    const socialHeadline = article?.socialHeadline ?? "";
    const headline = article?.headline ?? "";
    return findFirstNonEmptyString(socialHeadline, headline);
  };

  const avatarMap: AvatarMap = {
    0: <StyledAvatarImage alt={AvatarFirst.alt} src={AvatarFirst.src} />,
    1: <StyledAvatarImage alt={AvatarSecond.alt} src={AvatarSecond.src} />,
    2: <StyledAvatarImage alt={AvatarThird.alt} src={AvatarThird.src} />,
  };

  const isEven = index % 2 === 0;

  return (
    <Container $isEven={isEven} query={customQueryParameters} reference={article}>
      <DialogContainer>
        <StyledDialog.Desktop $isEven={isEven} />
        <StyledDialog.Mobile $isEven={isEven} />
        <StyledDialog.Tablet $isEven={isEven} />
        <TextContainer $isEven={isEven}>
          <HeadlineContainer $isEven={isEven}>
            <Headline>{renderHeadline()}</Headline>
          </HeadlineContainer>
          <StyledButton variant="button">READ MORE</StyledButton>
        </TextContainer>
      </DialogContainer>
      <AvatarContainer $isEven={isEven}>{avatarMap[index]}</AvatarContainer>
    </Container>
  );
};
HealthAndHappinessItem.displayName = "HealthAndHappinessItem";
